var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 1L4 4.5L1 8","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ChevronRight.defaultProps = {"width":"5","height":"9","viewBox":"0 0 5 9","fill":"none"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
